













import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Chips from '@/components/common/elements/Chips.vue';
import { AddDetailResponse } from '@/constants/components/addDetails'

@Component({
  components:{ Chips }
})
export default class AddDetails extends Vue {
  // 要素name属性
  @Prop({ default: '' })
  private name!: string;
  // 表示テキスト
  @Prop({ default: '明細行を追加する' })
  private text?: string;
  // 表示アイコンの切り替え(参考：https://materialdesignicons.com/)
  @Prop({ default: 'mdi-plus-circle-outline ' })
  private icon?: string;

  /**
   * 親コンポーネントに押下したか否か通知する
   * @module addDetailsOpratipon
   * @return {AddDetailResponse} - 要素名、押下判定
   */
  @Emit('addDetailsOpratipon')
  public addDetailsOpratipon(isPush: boolean): AddDetailResponse {
    return {name: this.name, action: isPush};
  }

}
